import App from "theme/base/App"
import "./theme.scss"
import cmsStore from "stores/cmsStore"

let templateConfig = {}

const fetchCategoryTemplates = () => {
    return fetch("/category-templates.json")
        .then(res => res.json())
        .then(res => {
            console.log("templateConfig", res)
            templateConfig = res
            cmsStore.addConfig("templateConfig", res)
            return res
        })
}
fetchCategoryTemplates()


export default App


// WEBPACK FOOTER //
// ./src/theme/fiebiger/App.js